import { useEffect } from 'react';

import { IUseAlertOrderLimit } from './types';

export const useAlertOrderLimit = ({
  appliedLoyaltyRewards,
  calculateCartTotal,
  alertOrderLimit,
  checkoutPriceLimit,
  setCartPriceLimitExceeded,
  setIsCartPriceAboveMinimumSpend,
  setMinimumSpendAmount,
}: IUseAlertOrderLimit) => {
  useEffect(() => {
    const limit = checkoutPriceLimit;
    const priceLimitExceeded = calculateCartTotal() > limit;
    if (Object.keys(appliedLoyaltyRewards).length > 0) {
      let minimumSpendAmount: number[] = [];
      const minSpend = Object.keys(appliedLoyaltyRewards).map(reward => {
        if (
          appliedLoyaltyRewards[reward].minimumSpend != null &&
          appliedLoyaltyRewards[reward].minimumSpend != undefined
        ) {
          const minimumSpend: number = appliedLoyaltyRewards[reward].minimumSpend as number;
          minimumSpendAmount.push(minimumSpend);
          return calculateCartTotal() > minimumSpend;
        } else {
          return true;
        }
      });
      setIsCartPriceAboveMinimumSpend(!minSpend.includes(false));
      setMinimumSpendAmount([...minimumSpendAmount]);
    } else {
      setIsCartPriceAboveMinimumSpend(true);
    }

    if (priceLimitExceeded) {
      alertOrderLimit();
    }

    setCartPriceLimitExceeded(priceLimitExceeded);
  }, [calculateCartTotal, alertOrderLimit, checkoutPriceLimit, setCartPriceLimitExceeded]);
};
